
<script>

import appConfig from "@/app.config";
import { versionamento } from '@/components/versionamento';

/**
 * Timeline component
 */
export default {
  page: {
    title: "Versões",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {},
  data() {
    return {
      versionamento: versionamento,
      title: "Versões",
      items: [
        {
          text: "Início",
          href: "/"
        },
        {
          text: "Versões",
          active: true
        }
      ]
    };
  },
  methods: {
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <ul class="verti-timeline list-unstyled">
            <li class="event-list" v-for="versao in versionamento" :key="versao.versao">
              <div class="event-timeline-dot">
                <i class="bx bx-right-arrow-circle"></i>
              </div>
              <div class="media">
                <div class="media-body">
                  <div>
                    <h5>{{ versao.versao }}</h5>
                    <ul class="list-group">
                      <simplebar>
                        <li v-show="versao.novidades.length > 0" class="list-group-item border-0">
                          <div class="media">
                            <div>
                              <i class="bx bx-star font-size-16 align-middle me-2"></i>
                            </div>
                            <div class="media-body">
                              <h5 class="font-size-16">Novidades</h5>
                              <ul class="list-group">
                                <li class="list-group-item" v-for="novidade in versao.novidades" :key="novidade">
                                  {{ novidade }}
                                </li>
                              </ul>
                            </div>
                          </div>
                        </li>
                        <li v-show="versao.ajustes.length > 0" class="list-group-item border-0">
                          <div class="media">
                            <div>
                              <i class="bx bx-wrench font-size-16 align-middle me-2"></i>
                            </div>
                            <div class="media-body">
                              <h5 class="font-size-16">Ajustes</h5>
                              <ul class="list-group">
                                <li class="list-group-item" v-for="ajuste in versao.ajustes" :key="ajuste">
                                  {{ ajuste }}
                                </li>
                              </ul>
                            </div>
                          </div>
                        </li>
                        <li v-show="versao.correcoes.length > 0" class="list-group-item border-0">
                          <div class="media">
                            <div>
                              <i class="bx bx-bug font-size-16 align-middle me-2"></i>
                            </div>
                            <div class="media-body">
                              <h5 class="font-size-16">Correções</h5>
                              <ul class="list-group">
                                <li class="list-group-item" v-for="correcao in versao.correcoes" :key="correcao">
                                  {{ correcao }}
                                </li>
                              </ul>
                            </div>
                          </div>
                        </li>
                      </simplebar>
                    </ul>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </Layout>
</template>